import React, { useContext } from 'react'
import { StoreContext } from "@context/StoreContext"

import { X } from '@phosphor-icons/react'
import { Dialog, DialogPanel, } from "@headlessui/react"

import EmptyBag from './EmptyBag'
import BagContents from './BagContents'
import Checkout from './Checkout'

const Cart = () => {
    const {isOpen, onClose, checkout} = useContext(StoreContext);

    const emptyCart = checkout?.lines?.edges?.length === 0
    const numberOfLineItems = checkout?.lines?.edges?.length;

    
    return (
        <React.Fragment>
            <Dialog open={isOpen} onClose={() => onClose()} className="relative z-[100]" >
                <div className="fixed inset-0 w-screen bg-black bg-opacity-60">
                    <DialogPanel transition className="relative flex w-full h-screen justify-end duration-150 ease-out data-[enter]:translate-x-full data-[leave]:translate-x-full z-20">
                        <button className='absolute w-screen h-screen z-0' onClick={() => onClose()} />
                        <div className="w-full md:w-[375px] h-full bg-white drop-shadow-lg flex flex-col">
                            <div className="flex flex-nowrap items-center justify-between p-4">
                                <div className="inline-flex gap-x-2 items-center">
                                    <h2 className="m-0">Bag</h2>
                                    {numberOfLineItems > 0 && (
                                    <h2 className="text-md m-0 pt-1">
                                        ({numberOfLineItems} item{numberOfLineItems !== 1 && "s"})
                                    </h2>
                                    )}
                                </div>
                                <X className="cursor-pointer" size={24} weight="light" onClick={() => onClose()} />
                            </div>

                            <div className={`overflow-y-scroll scrollbar-hide grid flex-grow ${!emptyCart && 'mb-[130px]'}`}>
                                {emptyCart ? <EmptyBag /> : <BagContents />}
                            </div>

                            <Checkout />
                        </div>
                    </DialogPanel>
                </div>
            </Dialog>
        </React.Fragment>
    );
}

export default Cart;